import emailjs from '@emailjs/browser';
import moment from 'moment';

interface IFormData {
  companyName: string;
  assetName: string;
  assetType: string;
  picName?: string;
  picPhoneNumber?: string;
  createdByUserEmail?: string;
}

export async function sendNewAsset(formData: IFormData) {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const toEmail = process.env.REACT_APP_EMAILJS_TO_EMAIL;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const createdAt = moment().format('DD MMM YYYY, HH:mm');

  const data = {
    ...formData,
    toEmail,
    createdAt,
    platform: 'Ramus 4.0',
  };

  console.log({ data });

  if (serviceId && templateId && toEmail && publicKey) {
    await emailjs.send(serviceId, templateId, data, publicKey).then(
      (result) => {
        console.log('Success create asset');
      },
      (error) => {
        console.error('Failed create asse :: Error: ', error);
      }
    );
  } else {
    console.error('Error 1.1 ::: Credential to update new asset not found');
  }
}

export interface ParamsType {
  companyName: string;
  assetName: string;
  assetType: string;
  picName?: string;
  picPhoneNumber?: string;
  createdByUserEmail?: string;
}

export const handleNewAsset = async (params: ParamsType) => {
  try {
    const createdAt = moment().format('DD MMM YYYY, HH:mm');

    const formData = {
      company: params.companyName,
      assetName: params.assetName,
      createdAt,
      jenis: params.assetType,
      picName: params.picName || '',
      picPhone: params.picPhoneNumber || '',
      status: 'New Asset',
      remark: '',
      sheet: 'Ramus 4.0',
    };

    const url = process.env.REACT_APP_SPREADSHEET_MACRO_URL;

    if (url) {
      await fetch(url, {
        method: 'POST',
        body: JSON.stringify(formData),
      });
      console.log('Success handle new asset');
    } else {
      console.error('Error 1.2 ::: Credential to update new asset not found');
    }
  } catch (error) {
    console.error(error);
    console.error('Failed handle new asset');
  }
};
